export const STEPS = Object.freeze([
    { step: 1, title: 'Upload CSV file with Contacts.' },
    { step: 2, title: 'Map your contact info.' },
]);

export const ROUTES = Object.freeze([
    { route: { name: 'contact-import-process' }, text: 'Import Contacts' },
    { route: { name: 'contact-import-reporting' }, text: 'Import History' },
]);

export const LS_PROCESSING_DATE = 'importContactsProcessingDate';
